module.exports = __webpack_public_path__ + "flowers.c46f6648.webp";